export default "__VITE_ASSET__DozGkG9k__"